import { useQuery } from '@tanstack/react-query';
import { getOpenAlertCount } from './api';

export const alertCountKeys = { open: ['alerts', 'open-count'] as const };

/** Silent: the dashboard tile just stays empty if the count fails. */
export function useOpenAlertCount() {
  return useQuery({
    queryKey: alertCountKeys.open,
    queryFn: ({ signal }) => getOpenAlertCount(signal),
    meta: { silent: true },
  });
}
